import { TEMPORARY_STORAGE_REASON_TYPE_ID, TEMPORARY_STORAGE_REASON_TYPE_NAME } from 'types/orders';

export const getReasonForStopWarehouse = (
  reasonId: TEMPORARY_STORAGE_REASON_TYPE_ID
): TEMPORARY_STORAGE_REASON_TYPE_NAME => {
  const reasonMap = {
    [TEMPORARY_STORAGE_REASON_TYPE_ID.CONFIGURATION]: TEMPORARY_STORAGE_REASON_TYPE_NAME.CONFIGURATION,
    [TEMPORARY_STORAGE_REASON_TYPE_ID.PREPARATION]: TEMPORARY_STORAGE_REASON_TYPE_NAME.PREPARATION,
    [TEMPORARY_STORAGE_REASON_TYPE_ID.INVOICE]: TEMPORARY_STORAGE_REASON_TYPE_NAME.INVOICE
  };
  return reasonMap[reasonId] || 'Razón desconocida';
};
